import { Client } from '@umanforge/common';

interface ClientPopupProps {
  clients: Client[];
  onSelect: ( client: Client ) => void;
  popupRef: React.RefObject<HTMLSpanElement>;
}

function ClientPopup( { clients, onSelect, popupRef }: ClientPopupProps ) {
  return (
    <span
      ref={popupRef}
      className="absolute p-2 gap-2 dark:bg-dark-bg-light overflow-hidden appear-jump flex flex-col font-title text-lg z-20 top-[60px] left-0 bg-white shadow-2xl drop-shadow-lg rounded-lg transition-all duration-300"
    >
      {clients.map( client => {return (
        <div
          key={client.id}
          onClick={() => {return onSelect( client );}}
          className="p-2 rounded-md hover:bg-gray-100 w-48 text-left"
        >
          {client.name}
        </div>
      );} )}
    </span>
  );
}

export default ClientPopup;
